var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCustomizeclose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_619_1951)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.5 17C13.1944 17 17 13.1944 17 8.5C17 3.80558 13.1944 0 8.5 0C3.80558 0 0 3.80558 0 8.5C0 13.1944 3.80558 17 8.5 17Z",
    fill: "black",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.12665 8.49908L11.7921 5.83079C11.8381 5.79082 11.8753 5.74181 11.9015 5.6868C11.9277 5.6318 11.9423 5.572 11.9444 5.51111C11.9464 5.45023 11.9359 5.38957 11.9135 5.33293C11.891 5.27629 11.8572 5.22488 11.814 5.1819C11.7708 5.13892 11.7193 5.1053 11.6625 5.08313C11.6058 5.06097 11.5451 5.05073 11.4842 5.05306C11.4233 5.05539 11.3636 5.07024 11.3087 5.09668C11.2538 5.12312 11.205 5.16059 11.1652 5.20675L8.49978 7.8722L5.83432 5.20675C5.74974 5.13321 5.64045 5.09444 5.52843 5.09822C5.41642 5.102 5.30999 5.14806 5.23056 5.22713C5.15113 5.3062 5.10459 5.41242 5.1003 5.52441C5.09601 5.63641 5.1343 5.74587 5.20745 5.83079L7.8722 8.49908L5.20745 11.1645C5.16451 11.2053 5.13018 11.2542 5.10647 11.3085C5.08275 11.3627 5.07014 11.4212 5.06937 11.4804C5.06861 11.5395 5.0797 11.5983 5.102 11.6531C5.1243 11.708 5.15735 11.7578 5.19921 11.7996C5.24107 11.8415 5.29089 11.8746 5.34572 11.8969C5.40056 11.9192 5.45931 11.9303 5.5185 11.9295C5.5777 11.9287 5.63614 11.9161 5.69038 11.8924C5.74462 11.8687 5.79356 11.8343 5.83432 11.7914L8.49978 9.12666L11.1652 11.7921C11.2485 11.8752 11.3613 11.9219 11.4789 11.9218C11.5966 11.9218 11.7093 11.875 11.7925 11.7918C11.8756 11.7085 11.9223 11.5957 11.9222 11.4781C11.9221 11.3604 11.8753 11.2477 11.7921 11.1645L9.12665 8.49908Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_619_1951"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 17,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomizeclose);
export default __webpack_public_path__ + "static/media/customizeclose.570da949c2a7393dcc3142b0a986ec5c.svg";
export { ForwardRef as ReactComponent };